var ModalConductor = {

  stack: [],

  current: function () {
    return this.stack[this.stack.length - 1];
  },

  activate: function(modalClass) {

    if (this.stack.length > 0) {
      this.current().diactivate();
    }

    var current = resolve(modalClass);
    current.activate.apply(current, Array.prototype.slice.call(arguments, 1));
    current.on('closed', () => {
      var currentIndex = this.stack.indexOf(current);
      for (var i = this.stack.length - 1; i >= currentIndex; i--) {
        //this.stack[i].close();
        this.stack.pop();
      }

      if (this.current()) this.current().show();
    });
    this.stack.push(current);
    return current;
  }
};
